module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/aabdo0-e860bda651891485796f6f345fc557f0.jpg";